import React from 'react'
import cx from 'classnames'

import { Field } from './common/Field/Field'

import styles from './Form.module.scss'

type FormProps = {
  children?: React.ReactNode
  className?: string
  onSubmit?: React.FormEventHandler<HTMLFormElement>
}

type FormComponent = ((props: FormProps) => React.JSX.Element) & {
  Field: typeof Field
}

export const Form: FormComponent = Object.assign(
  ({ children, className, onSubmit }: FormProps) => (
    <form
      className={cx(styles.form, className)}
      // Submitting is always handled here. Left to the browser, pressing enter
      // in a field navigates to the current url, which reloads the page and
      // throws away whatever the user had filled in.
      onSubmit={event => {
        event.preventDefault()
        onSubmit?.(event)
      }}
    >
      {children}
    </form>
  ),
  {
    Field,
  },
)
